export const projects = [
  {
    id: 1,
    name: "personal website",
    img: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bGFwdG9wJTIwY29kZXxlbnwwfHwwfHw%3D&w=1000&q=80",
    siteLink: "",
    codeLink: "",
    desc: "the best of the best",
  },
  {
    id: 2,
    name: "insta clone",
    img: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bGFwdG9wJTIwY29kZXxlbnwwfHwwfHw%3D&w=1000&q=80",
    siteLink: "",
    codeLink: "",
    desc: "the best of the best",
  },
  {
    id: 3,
    name: "Younotes App",
    img: "https://gdurl.com/8K7u",
    siteLink: "https://younotes-app-1.herokuapp.com/notes",
    codeLink: "https://github.com/CliffMaz/YouNote-App",
    desc: "An application for taking/making notes. For frontend i used angular and for backend i used Spring Boot",
  },
];
